<footer class="Footer">
	<div class="Section-container">
		<img src="/images/summitBrandingLogo-blackOnClear.png" alt="Summit Branding Logo">
		<span class="Footer-copyright">&copy; Summit Branding LLC</span>
	</div>
</footer>

<style>
	.Footer {
		font-size: 30px;
		padding: 25px 50px;
	}
	.Section-container {
		align-items: center;
		display: flex;
		margin: 0 auto;
		max-width: 1100px;
		width: 100%;
	}
	.Footer-copyright {
		margin-left: 50px;
	}
</style>